import React from 'react'
import moment from 'moment'
import {
  ToolbarComponent,
  ItemsDirective,
  ItemDirective,
} from '@syncfusion/ej2-react-navigations'
import type { ClickEventArgs } from '@syncfusion/ej2-react-navigations'
import TagBadge from '@components/common/TagBadge/TagBadge.component'

type NoteEditorBottomBarProps = {
  viewOnly: boolean
  defaultTag: string
  tag: string
  date: Date
  showSaveAction?: boolean
  onBottomToolbarClick: (args: ClickEventArgs) => void
}

const NoteEditorBottomBar: React.FC<NoteEditorBottomBarProps> = ({
  viewOnly,
  defaultTag,
  tag,
  date,
  showSaveAction = true,
  onBottomToolbarClick,
}) => {
  const effectiveTag = tag || defaultTag

  return (
    <div className="note-bottom-toolbar">
      {!viewOnly && (
        <ToolbarComponent id="bottomToolbar" clicked={onBottomToolbarClick}>
          <ItemsDirective>
            <ItemDirective
              id="tb-undo"
              prefixIcon="e-undo"
              tooltipText="Undo"
            />
            <ItemDirective
              id="tb-redo"
              prefixIcon="e-redo"
              tooltipText="Redo"
            />
          </ItemsDirective>
        </ToolbarComponent>
      )}
      <div className="right-toolbar">
        Tagged as <TagBadge tag={effectiveTag} />
        <span className="date">{`Created on ${moment(date).format('MM-DD-YYYY')}`}</span>
        {!viewOnly && showSaveAction && (
          <ToolbarComponent id="bottomToolbar2" clicked={onBottomToolbarClick}>
            <ItemsDirective>
              <ItemDirective
                id="tb-save"
                prefixIcon="mgc_save_2_fill"
                tooltipText="Save"
              />
            </ItemsDirective>
          </ToolbarComponent>
        )}
      </div>
    </div>
  )
}

export default NoteEditorBottomBar
